import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
	FiPlus,
	FiSearch,
	FiUsers,
	FiDownload,
	FiMoreHorizontal,
} from 'react-icons/fi';
import { FormGroup, FormControl, Dropdown } from 'react-bootstrap';
import Loading from 'components/Loading';
import Layout from 'components/Layout';
import StaffingLevelList from 'components/StaffingLevels';
import StaffingLevelEditModal, { STAFFING_LEVEL_MODAL_STYLE } from 'components/StaffingLevels/StaffingLevelEditModal';
import { showModal, hideModal } from 'actions/modalActions';
import * as groupsActions from 'actions/groupsActions';
import * as calendarsActions from 'actions/calendarsActions';
import * as functionsActions from 'actions/functionsActions';
import * as shiftsActions from 'actions/shiftsActions';
import * as ubicationsActions from 'actions/ubicationsActions';
import Modal from 'components/Modal';
import { helpUrls } from 'utils/helpUrls';
import { withTranslation } from 'react-i18next';
import HelpBanner from 'components/HelpBanner';

class StaffingLevels extends Component {
	constructor(props) {
		super(props);

		this.state = {
			searchStaffingLevel: '',
		};

		// console.log(props);
		this.closeModal = this.closeModal.bind(this);
		this.openNewStaffingLevelModal = this.openNewStaffingLevelModal.bind(this);
		this.getStaffingLevels = this.getStaffingLevels.bind(this);

		this.searchTimeout = null;
	}

	componentDidMount() {
		this.getStaffingLevels();
		this.props.getSelectableDayTypes();
		this.props.getSelectableFunctions();
		this.props.getAttendanceShifts();
		this.props.getAllUbications();
	}

	componentWillUnmount() {
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}
	}

	handleChangeSearch = (event) => {
		this.setState(
			{
				[event.target.id]: event.target.value,
			},
			() => {
				this.debouncedSearch();
			}
		);
	};

	debouncedSearch = () => {
		if (this.searchTimeout) {
			clearTimeout(this.searchTimeout);
		}

		this.searchTimeout = setTimeout(() => {
			this.getStaffingLevels();
		}, 500);
	};

	async getStaffingLevels() {
		await this.props.getStaffingLevels(this.state.searchStaffingLevel);
	}

	closeModal() {
		this.props.hideModal();
	}

	openNewStaffingLevelModal() {
		this.props.showModal(
			{
				open: true,
				title: this.props.t('staffingLevels.createModal'),
				style: STAFFING_LEVEL_MODAL_STYLE,
				content: (
					<StaffingLevelEditModal
						handleClose={this.closeModal}
						getStaffingLevels={this.getStaffingLevels}
					/>
				),
				closeModal: this.closeModal,
			},
			'edit'
		);
	}

	getContent = () => {
		if (this.props.loading) {
			return <Loading />;
		}

		if (!this.props.staffing_levels) {
			return this.props.t('staffingLevels.errorLoading');
		}

		if (this.props.staffing_levels.length == 0) {
			return (
				<div className="first-steps">
					<FiUsers className="icono-pasos" />
					<h3 className="title2">{this.props.t('staffingLevels.firstSteps.title')}</h3>

					<p>
						{this.props.t('staffingLevels.firstSteps.las')} <strong>{this.props.t('staffingLevels.firstSteps.staffingLevels')}</strong> {this.props.t('staffingLevels.firstSteps.text1')}{' '}
						<strong>{this.props.t('staffingLevels.firstSteps.employees')}</strong> {this.props.t('staffingLevels.firstSteps.text2')}{' '}
						<a className="alink" target="_blank" href={helpUrls.function}>
							<strong>{this.props.t('staffingLevels.firstSteps.functionLabel')}</strong>
						</a>{' '}
						{this.props.t('staffingLevels.firstSteps.text3')}{' '}
						<a className="alink" target="_blank" href={helpUrls.shift}>
							<strong>{this.props.t('staffingLevels.firstSteps.shiftLabel')}</strong>
						</a>
						{this.props.t('staffingLevels.firstSteps.text4')}{' '}
						<a className="alink" target="_blank" href={helpUrls.needs}>
							{helpUrls.needs}
						</a>
					</p>
				</div>
			);
		}

		return (
			<StaffingLevelList
				staffing_levels={this.props.staffing_levels}
				getStaffingLevels={this.getStaffingLevels}
			/>
		);
	};

	render() {
		return (
			<>
				<Layout
					configSidebar={true}
					className="page-staffing-levels"
					context="groups"
				>
					<div className="heading">
						<h1 className="title">{this.props.t('staffingLevels.title')}</h1>
						<div className="heading-help-banner heading-config hidden-sm">
							<HelpBanner
								title={this.props.t('common.needHelp')}
								text={this.props.t('common.helpText')}
								linkText={this.props.t('common.moreInfo')}
								linkHref="https://help.plain.ninja/es/collections/12657248-necesidades-de-personal"
							/>
						</div>
						<div className="heading-filters">
							<FormGroup
								className="form-group form-search"
								controlId="searchStaffingLevel"
							>
								<FormControl
									type="text"
									placeholder={this.props.t('common.searchPlaceholder')}
									value={this.state.searchStaffingLevel}
									onChange={this.handleChangeSearch}
								/>
								<FiSearch />
							</FormGroup>
						</div>
						<div className="heading-actions">
							<button
								type="button"
								title={this.props.t('staffingLevels.createButton')}
								onClick={this.openNewStaffingLevelModal}
								className="btn btn-new"
							>
								<FiPlus />
							</button>

							<Dropdown>
								<Dropdown.Toggle variant="action">
									<FiMoreHorizontal />
								</Dropdown.Toggle>
								<Dropdown.Menu>
									<Dropdown.Item
										as="button"
										onClick={() =>
											this.props.history.push('/staffing-levels/import')
										}
									>
										<FiDownload /> {this.props.t('staffingLevels.importStaffingLevels')}
									</Dropdown.Item>
								</Dropdown.Menu>
							</Dropdown>
						</div>
					</div>

					{this.getContent()}
				</Layout>

				<Modal hideModal={this.props.hideModal} />
			</>
		);
	}
}

const mapStateToProps = (reducers) => {
	return {
		...reducers.groupsReducer,
		...reducers.calendarsReducer,
		...reducers.functionsReducer,
		...reducers.shiftsReducer,
		...reducers.ubicationsReducer,
		loading: reducers.groupsReducer.loading,
	};
};

const mapDispatchToProps = (dispatch) => ({
	hideModal: () => dispatch(hideModal()),
	showModal: (modalProps, modalType) => {
		dispatch(showModal({ modalProps, modalType }));
	},
	getStaffingLevels: (q) => dispatch(groupsActions.getAllStaffingLevels(q)),
	getSelectableDayTypes: () =>
		dispatch(calendarsActions.getSelectableDayTypes()),
	getSelectableFunctions: () =>
		dispatch(functionsActions.getSelectableFunctions()),
	getAttendanceShifts: () => dispatch(shiftsActions.getAttendanceShifts()),
	getAllUbications: () =>
		dispatch(ubicationsActions.getAllUbications({ enabled: true })),
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(StaffingLevels));
